import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RaisedButtonComponent } from './raised-button.component';



@NgModule({
  declarations: [RaisedButtonComponent],
  imports: [
    CommonModule
  ],
  exports: [RaisedButtonComponent]
})
export class RaisedButtonModule { }
